
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dealer",
      function () {
        return require("private-next-pages/dealer/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dealer"])
      });
    }
  